import { cn } from '@talentmesh/ui/lib/utils';
import React from 'react';
import TopBar from './TopBars/TopBar';

const Page = ({ children, className, ...props }: React.PropsWithChildren<React.HTMLAttributes<HTMLDivElement>>) => {
    return (
        <div className={cn('flex h-screen flex-col', className)} {...props}>
            <TopBar />
            {children}
        </div>
    );
};

export default Page;
